module.exports = __webpack_public_path__ + "img/debt2.5781c0c3.jpg";